import useSubscriptions from 'services/general/subscriptionsList';
import useCheckoutKit from 'hooks/useCheckoutKit';
import { KitType } from '@repo/types';

import { Typography } from '@repo/ui';
import resampleBg from 'assets/images/summary/resample_bg.png';
import logoPlus from 'assets/images/logos/logo-plus-white.svg';
import GenericCardWithImage from 'components/GenericCardWithImage/GenericCardWithImage';

import styles from './ResampleCard.module.scss';

const ResampleCard = ({ samplingType }: { samplingType?: KitType }) => {
  const { isAnyTinyPlus, isTinyPlus } = useSubscriptions();
  const { checkoutUrl } = useCheckoutKit({ kitType: samplingType });

  return (
    <GenericCardWithImage
      section={
        isAnyTinyPlus ? 'Tiny+ member-only pricing' : 'Get your next kit'
      }
      title={
        isAnyTinyPlus
          ? isTinyPlus
            ? 'Get another test for $149'
            : 'Get another test for $169'
          : 'Track changes over time and fine-tune'
      }
      link={`${checkoutUrl}&utm_source=tinyhealth&utm_medium=webapp&utm_campaign=resample-cta`}
      external
      cta='Order now'
      image={resampleBg}
      overlay={
        <div className={styles.overlay}>
          {isAnyTinyPlus ? (
            <img src={logoPlus} alt='tiny plus logo' />
          ) : (
            <Typography variant={'label'} className={styles.badge}>
              {'$20 off'}
            </Typography>
          )}
        </div>
      }
    />
  );
};

export default ResampleCard;
